module.exports = __webpack_public_path__ + "media/img/scholarships/Maths Year 13-6b0fe4242c8270e7abcb8301b00146b0.svg";